import styled from 'styled-components'

const mediaScreenMobile = props => `@media screen and (max-width: ${props.theme.screens.medium})`

export default styled.div`
    flex: 1;
    flex-basis: 100%;
    position: relative;

    ${mediaScreenMobile} {
        display: none;
    }
`
